import { EMetric, metricDictionary } from 'api/useAnalytics';
import { Decimal } from 'decimal.js';

import {
  BaseStatistic,
  EStatisticType
} from '../../../views/Statistics/StatisticsView.types';

export const formatTrendsDataForChart = (
  trends: BaseStatistic[],
  metricName: EMetric
) => {
  const allDates = Array.from(
    new Set(trends.flatMap((trend) => trend.values.map((d) => d.date)))
  ).sort();

  const chartData = allDates.map((date) => {
    const dataPoint: { [key: string]: string | number | null } = { date };
    trends.forEach((trend) => {
      const trendValue =
        trend.values.find((d) => d.date === date)?.value ?? null;

      const metricMetaData = metricDictionary[metricName];
      const metricType = metricMetaData?.type ?? EStatisticType.NUMBER;

      const processedValue =
        metricType === EStatisticType.AMOUNT_AVERAGE ||
        metricType === EStatisticType.CURRENCY
          ? new Decimal(trendValue ?? 0).div(100).toNumber()
          : trendValue;
      dataPoint[trend.name] = processedValue;
    });
    return dataPoint;
  });

  return chartData;
};
